import { makeStyles } from "@material-ui/core/styles"

import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	upsellCard: {
		backgroundColor: themeColors.colors.system.purple[50],
		border: `1px solid ${themeColors.colors.system.purple[200]}`,
		borderRadius: 8,
		padding: 16
	},
	benefitIconBox: {
		backgroundColor: themeColors.colors.system.gray[0],
		borderRadius: 8,
		width: 40,
		height: 40,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexShrink: 0
	},
	benefitTitle: {
		fontWeight: 700
	}
}))

export default useStyles
